import React from 'react';
import { observer } from 'mobx-react';

import { ComponentBase, InjectedStyledComponent } from '../../../../../shared/index.js';
import Image from '../../../Image/Image.js';
import Translate from '../../../Translate/Translate.js';
import { TranslationContext } from '../../../Translate/Translate.js';
import ButtonToggle from '../../styledComponents/DatePickerInput/ButtonToggle.js';
import Input from '../../styledComponents/DatePickerInput/Input.js';
import InputWrapper from '../../styledComponents/DatePickerInput/InputWrapper.js';
import ToggleIcon from '../../styledComponents/DatePickerInput/ToggleIcon.js';

import { IDatePickerInputConfiguration, IDatePickerInputProps, IDatePickerInputState } from './models/index.js';
import {
	DATE_PICKER_INPUT_CATEGORY_KEY,
	DATE_PICKER_INPUT_COMPONENT_KEY,
	DATE_PICKER_INPUT_PARENT_COMPONENT_KEY,
} from './DatePickerInput.meta.js';

export class DatePickerInput extends ComponentBase<
	IDatePickerInputProps,
	IDatePickerInputState,
	IDatePickerInputConfiguration
> {
	categoryKey = DATE_PICKER_INPUT_CATEGORY_KEY;
	componentKey = DATE_PICKER_INPUT_COMPONENT_KEY;
	get parentComponentKey(): string | undefined {
		return DATE_PICKER_INPUT_PARENT_COMPONENT_KEY;
	}

	constructor(props: IDatePickerInputProps) {
		super(props);
	}
	render() {
		const {
			onClick,
			dateFormatter,
			localization,
			name,
			formattedValue,
			valueAsDate,
			value,
			identifier,
			disabled,
			required,
			role,
			labelId,
			buttonRef,
			inputRef,
			onInput,
			onBlur,
			onFocus,
		} = this.props;

		return (
			<TranslationContext.Consumer>
				{(translationContext) => {
					return (
						<InputWrapper className="input-wrapper">
							<Input
								key={formattedValue}
								className="input"
								defaultValue={formattedValue}
								placeholder={translationContext.translate(localization.placeholder)}
								id={identifier}
								disabled={disabled}
								role={role}
								required={required ? true : undefined}
								aria-autocomplete="none"
								onInput={onInput}
								onFocus={onFocus}
								onBlur={onBlur}
								autoComplete="off"
								innerRef={inputRef}
								aria-labelledby={labelId}
							/>
							<input type="hidden" name={name} value={value} />
							<ButtonToggle
								className="toggle"
								onClick={onClick}
								disabled={disabled}
								innerRef={buttonRef}
								type="button"
							>
								<ToggleIcon className="toggle-icon">
									<Image aria-hidden={true} asset="base.datePicker.calendar"></Image>
								</ToggleIcon>
								<span className="vhidden">
									<Translate>{localization.buttonLabel}</Translate>
									{valueAsDate && (
										<span>
											, <Translate>{localization.selectedDateMessage}</Translate>{' '}
											{dateFormatter.format(valueAsDate)}
										</span>
									)}
								</span>
							</ButtonToggle>
						</InputWrapper>
					);
				}}
			</TranslationContext.Consumer>
		);
	}
}

export default InjectedStyledComponent(
	observer(DatePickerInput),
	DATE_PICKER_INPUT_CATEGORY_KEY,
	DATE_PICKER_INPUT_PARENT_COMPONENT_KEY,
	[DATE_PICKER_INPUT_COMPONENT_KEY],
);
